/**
 * File Preview Dialog
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { X, Download } from 'lucide-react';

export const FilePreviewDialog = ({ 
  file, 
  blobUrl, 
  loading, 
  onClose, 
  onDownload 
}) => {
  if (!file) return null;

  const isImage = file.content_type?.startsWith('image/');
  const isPdf = file.content_type === 'application/pdf';

  return (
    <Dialog open={!!file} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-4xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span className="truncate mr-4">{file.filename}</span>
            <div className="flex gap-2">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={() => onDownload(file)}
                data-testid="download-preview-file"
              >
                <Download className="w-4 h-4 mr-1" /> Descarcă
              </Button>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={onClose}
                data-testid="close-preview"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4 flex items-center justify-center min-h-[300px] max-h-[70vh] overflow-auto bg-slate-100 rounded-lg">
          {loading ? (
            <div className="flex flex-col items-center gap-2">
              <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
              <p className="text-sm text-slate-500">Se încarcă...</p>
            </div>
          ) : blobUrl ? (
            isImage ? (
              <img 
                src={blobUrl} 
                alt={file.filename}
                className="max-w-full max-h-[65vh] object-contain"
                data-testid="preview-image"
              />
            ) : isPdf ? (
              <object
                data={blobUrl}
                type="application/pdf"
                className="w-full h-[65vh]"
                data-testid="preview-pdf"
              >
                <p>Browserul nu poate afișa PDF-ul. 
                  <Button variant="link" onClick={() => onDownload(file)}>
                    Descărcați fișierul
                  </Button>
                </p>
              </object>
            ) : (
              <div className="text-center p-8">
                <p className="text-slate-600 mb-4">
                  Acest tip de fișier nu poate fi previzualizat.
                </p>
                <Button onClick={() => onDownload(file)}>
                  <Download className="w-4 h-4 mr-2" /> Descarcă fișierul
                </Button>
              </div>
            )
          ) : (
            <p className="text-slate-500">Eroare la încărcarea fișierului</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
